<template>
  <div class="aside-actions" :style="{width: '100%'}">
    <div>
      <div v-if="showEnquireNowButton" data-test="enquire_now">
        <button :id="theId" class="btn--product-aside product-aside-enquire-now" @click="redirectToLink">{{ enquireNowText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
const hardCodedLinks = () => {
  return [
    {
      productId: "gid://shopify/Product/15372118851929",
      link: "/midleton-very-rare/midleton-very-rare-silent-distillery-ch6-book-a-callback/",
      expDate: new Date("2025-04-22")
    },
    {
      productId: "gid://shopify/Product/8541775757534",
      link: "/jameson/some_forwarded_page",
      expDate: new Date("2025-04-11")
    }
  ]
}

export default {
  props: {
    product: Object
  },
  computed: {
    theId() {
      const validLink = this.isValidProduct();
      return validLink ? 'enquireNowRedirect' : 'enquireNowSleek';
    },
    showEnquireNowButton() {
      const validProduct = this.isValidProduct();
      if (validProduct) {
        return true;
      }
      return this.product?.shopify_metafields?.buyable_enquire_now ||
        this.product?.shopify_metafields?.enquire_now && !this.product?.shopify_metafields?.coming_soon;
    },
    enquireNowText() {
      if (this.product?.shopify_metafields?.buyable_enquire_now) {
        return 'Request A Callback';
      }
      return 'REGISTER YOUR INTEREST';
    }
  },
  methods: {
    isValidProduct() {
      const validLink = this.getValidLink();
      return validLink && new Date() < new Date(validLink.expDate);
    },
    getValidLink() {
      return hardCodedLinks().find(link => link.productId === this.product?.shopify_id);
    },
    redirectToLink() {
      const validLink = this.getValidLink();
      if (validLink && new Date() < new Date(validLink.expDate)) {
        window.location.href = validLink.link;
      }
    }
  }
}
</script>
